/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose how your player UUID is handled on game servers.`)
};

const zh_hans1_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择游戏服务器如何处理您的玩家 UUID 与存档档案。`)
};

const zh_hant1_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇遊戲伺服器如何處理您的玩家 UUID 與存檔檔案。`)
};

const fr_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez comment votre UUID joueur est géré sur les serveurs de jeu.`)
};

const de_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie, wie Ihre Spieler-UUID auf Spielservern gehandhabt wird.`)
};

const ja_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲームサーバー上でのプレイヤーUUIDの扱いを選択します。`)
};

const ko_settings_minecraft_identity_mode_desc = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 서버에서 플레이어 UUID를 처리하는 방식을 선택합니다.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_minecraft_identity_mode_desc = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_minecraft_identity_mode_desc(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_minecraft_identity_mode_desc", locale)
	if (locale === "en") return en_settings_minecraft_identity_mode_desc(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_minecraft_identity_mode_desc(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_minecraft_identity_mode_desc(inputs)
	if (locale === "fr") return fr_settings_minecraft_identity_mode_desc(inputs)
	if (locale === "de") return de_settings_minecraft_identity_mode_desc(inputs)
	if (locale === "ja") return ja_settings_minecraft_identity_mode_desc(inputs)
	return ko_settings_minecraft_identity_mode_desc(inputs)
};